import React from "react";

function SchoolYearScopeNotice() {
  return (
    <div className="alert alert-warning manage-text" role="alert">
      Ten widok nie jest jeszcze w pelni filtrowany globalnym rokiem szkolnym.
    </div>
  );
}

export default SchoolYearScopeNotice;
